import React, { Component } from 'react';
class SearchForm extends Component {
    
     render() { 

        let  {searchDocument,showSearchResults,departmentToSearchIn,handleChangeKeyword,clearSearch,changeDepartment,departments,keywordToSearch,isSearching} = this.props
        let selected = (departmentToSearchIn === "") ? 'selected':""
        return ( 
            <div className="py-40 md:py-20 text-center md:text-left mt-8 relative bg-white rounded-md">
            <div className="absolute top-6 ml-24 md:ml-8">
                <span className="font-extrabold">Search Files</span>
                <span className="block text-xs font-semibold mt-2 filter">Use the different filters to find the file you need</span>
                <form onSubmit={searchDocument}>
                <div className="grid mt-4 md:grid-cols-5 gap-4">
                    <div className="sm:cols-span-2">
                     <select name="" onChange={changeDepartment}  className="w-full text-sm px-2 py-1  border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500" id="">
                       <option selected={selected} disabled className="text-sm" value="">select department..</option>
                         {
                             departments.map(department=>{
                                 return(
                                     <option key={department.id} className="text-sm" value={department.id}>{department.title}</option>
                                 )
                             })
                         }
                     </select>
                    </div>
                    <div className="sm:cols-span-3">
                    <input type="text" value={keywordToSearch} onChange={handleChangeKeyword} name="text" id="text" placeholder="search keyword" size="20"  className="w-full px-2 py-1 text-sm  border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-indigo-100 focus:border-indigo-300 dark:bg-gray-700 dark:text-white dark:placeholder-gray-500 dark:border-gray-600 dark:focus:ring-gray-900 dark:focus:border-gray-500"
                   />
                    </div>
                    {
                        showSearchResults ?
                              <button onClick={clearSearch} className="w-full md:px-2 px-5 py-2 text-white font-semibold text-xs bg-green-500 rounded-md">Clear Search</button>
                              :
                        <div className="sm:cols-span-2">
                              <button disabled = {isSearching ? "disabled" : ""} type="submit" className={isSearching ? "w-full md:px-2 px-5 py-2 text-gray-400 font-bold text-xs bg-gray-100 rounded-md":"w-full md:px-2 px-5 py-2 text-gray-900 font-bold text-xs bg-gray-200 rounded-md"}>
                                  {
                                      isSearching ? "Searching......": "Search"
                                  }
                              </button>
                         </div>
                    }
                </div>
                </form>
           </div>
</div>
         );
    }
}
 
export default SearchForm;